module.exports = __webpack_public_path__ + "c_static/img/淘气值截图.331c902.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/完善资料/淘气值截图.jpg
// module id = mTl4
// module chunks = 33